/**
 * Get the Template based on the chosen CTA
 * @module getTemplateHTMLById
 * @param {string} id - template id
 */
export default function getTemplateHTMLById(id) {
  const template = document.getElementById(id);

  if (!template) {
    throw new Error(`Template not found: ${id}`);
  }

  return document.importNode(template.content, true);
}



// WEBPACK FOOTER //
// ./styleguide/src/assets/lib/get-template-html-by-id.js